import * as XLSX from "xlsx";
import { jsPDF } from "jspdf";
import { Modal } from "antd";
import {
  drawPayoutCard,
  loadCalibriFont,
  measurePayoutCardHeight,
} from "./payout_list_pdf";

export const downloadPayoutList = (selectedPayoutData, payPeriodText) => {
  const exportRows = selectedPayoutData.map((item) => ({
    "Full Name": item.fullName || "",
    Category: item.category || "",
    Payrate: Number(item.payrate || 0),
    "Total Time": Number(item.totalTime || 0),
    "Regular Hrs": Number(item.regularHrs || 0),
    "After-Hrs": Number(item.afterHrs || 0),
    "Holiday Hrs": Number(item.holidayHrs || 0),
    Bonus: Number(item.bonus || 0),
    KiwiSaver: Number(item.kiwiSaver || 0),
    "Fuel Support": Number(item.fuelSupport || 0),
    "Total Payout": Number(item.totalPayout || 0),
    Cash: Number(item.cash || 0),
    Bank: Number(item.bank || 0),
    "Rounding Hrs": item.roundingHr === "-" ? "-" : Number(item.roundingHr || 0),
    Paid: (item.completed ?? item.status) ? "✓" : "",
  }));

  const worksheet = XLSX.utils.json_to_sheet(exportRows);
  worksheet["!cols"] = [
    { wch: 24 }, { wch: 12 }, { wch: 12 }, { wch: 14 }, { wch: 14 },
    { wch: 12 }, { wch: 14 }, { wch: 12 }, { wch: 12 }, { wch: 14 },
    { wch: 16 }, { wch: 12 }, { wch: 12 }, { wch: 14 }, { wch: 10 },
  ];
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Payout List");
  XLSX.writeFile(workbook, `Payout_List_${payPeriodText.replaceAll(" ", "_")}.xlsx`);
};

export const downloadPayoutCard = async (
  selectedPayoutData,
  payPeriodText,
  payoutRates = {},
) => {
  if (!selectedPayoutData.length) {
    Modal.warning({ title: "No data", content: "There is no payout data to download." });
    return;
  }

  const doc = new jsPDF({ orientation: "portrait", unit: "mm", format: "a4" });
  await loadCalibriFont(doc);

  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();
  const cardsPerRow = 3;
  const marginX = 7;
  const marginY = 6;
  const cardGapX = 5;
  const cardGapY = 5;
  const cardWidth =
    (pageWidth - marginX * 2 - cardGapX * (cardsPerRow - 1)) / cardsPerRow;
  // Baseline height of the old fixed 3 x 4 grid; cards only grow past it when
  // the staff worked at enough shops to need a taller shift table.
  const minCardHeight = (pageHeight - marginY * 2 - cardGapY * 3) / 4;
  const maxCardHeight = pageHeight - marginY * 2;

  // Rows of 3 cards, each row as tall as its tallest card, wrapping to a new
  // page when the next row would not fit.
  let currentY = marginY;

  for (let index = 0; index < selectedPayoutData.length; index += cardsPerRow) {
    const rowStaff = selectedPayoutData.slice(index, index + cardsPerRow);
    const rowHeight = Math.min(
      maxCardHeight,
      Math.max(
        minCardHeight,
        ...rowStaff.map((staff) => measurePayoutCardHeight(staff)),
      ),
    );

    if (index > 0 && currentY + rowHeight > pageHeight - marginY) {
      doc.addPage();
      currentY = marginY;
    }

    const rowY = currentY;
    rowStaff.forEach((staff, col) => {
      drawPayoutCard(
        doc,
        staff,
        marginX + col * (cardWidth + cardGapX),
        rowY,
        cardWidth,
        rowHeight,
        payPeriodText,
        payoutRates,
        true,
      );
    });

    currentY += rowHeight + cardGapY;
  }

  doc.save(`Payout_Cards_${payPeriodText.replaceAll(" ", "_")}.pdf`);
};
